import { ReactNode } from 'react'
import styled from 'styled-components'
var fonstsize = 18

export const CircleAnnotation = ({
  children,
  size = 80,
  angle = 0,
}: {
  children: ReactNode
  size?: number
  angle?: number
}) => {
  var textanchor =
    angle === 90 || angle === 270
      ? 'middle'
      : angle > 90 && angle < 270
      ? 'end'
      : 'start'

  var offset =
    angle === 90
      ? fonstsize * 1.5
      : angle > 0 && angle < 180
      ? fonstsize
      : fonstsize * 0.5

  var labelPos = pointOnCircle(0, 0, size + offset, angle)

  return (
    <g transform={`translate(${0},${0})`}>
      <AreaCircle r={size} fill='#f00' />
      <Text x={labelPos.x} y={labelPos.y} textAnchor={textanchor} fill={"var(--anno-text-color)"}>
        {children}
      </Text>
    </g>
  )
}

const AreaCircle = styled.circle`
  fill: none;
  stroke: var(--text-color);
  stroke-width: 2;
  /* stroke-dasharray: 4 5; */
  stroke-linecap: round;
`
const Text = styled.text`
  font-weight: 700;
  font-size: ${fonstsize}px;
  color: var(--anno-text-color);
  @media screen and (max-width: 712px) {
    font-size: 14px;
  }
`

function pointOnCircle(cx: number, cy: number, r: number, angle_deg: number) {
  var angle_rad = (angle_deg * Math.PI) / 180
  var x = cx + r * Math.cos(angle_rad)
  var y = cy + r * Math.sin(angle_rad)
  return { x: x, y: y }
}
